import { useTranslation } from '@/lib/i18n/react';
import { useQueryClient } from '@tanstack/react-query';
import { acceptChatCreationReview, reviewChatCreation, useChatCreationState } from '../creation-actions';

/** Shared across full chat/hub and survives a form remount. It never announces
 * successful creation based on a later GET or repeats the failed POST. */
export function ChatCreationStatus() {
  const {t}=useTranslation();
  const qc=useQueryClient();
  const action=useChatCreationState(s=>s.action);
  if(!action||action.phase==='pending')return null;
  const reviewing=action.phase==='reviewing',reviewed=action.phase==='reviewed';
  return <div className="chat-creation-status space-y-2 border-y border-blaze-orange/25 bg-blaze-orange/5 p-3 text-xs">
    <p role="status" aria-live="polite">{t('comms.creation.'+(reviewed?'reviewed':reviewing?'reviewing':action.failed?'review_failed':'unconfirmed'))}</p>
    {reviewed&&<>
      <p>{t('comms.creation.review_count',{count:action.review?.length??0})}</p>
      <ol className="max-h-32 space-y-1 overflow-auto">{action.review?.map(channel=><li key={channel.id}><bdi>{channel.display_name||channel.name}</bdi></li>)}</ol>
    </>}
    <button type="button" className="min-h-11 rounded-md border border-blaze-orange/30 px-3 font-semibold" disabled={reviewing} onClick={()=>{if(reviewed)acceptChatCreationReview();else void reviewChatCreation().then(()=>{void qc.invalidateQueries({queryKey:['team-chat','channels']});}).catch(()=>{});}}>
      {t('comms.creation.'+(reviewed?'continue':'review'))}
    </button>
  </div>;
}
